import { Box, Center, Input, SegmentedControl } from "@mantine/core";
import { IconMoon, IconSun } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

const ACCENT = 'var(--mantine-color-smartico-pink-6)';

const SEGMENTED_BORDER_STYLES = {
  indicator: { backgroundColor: 'var(--mantine-color-body)', border: `2px solid ${ACCENT}`, boxShadow: 'none' },
};

export const GradientTypeComponent = (props) => {

    const { t } = useTranslation();
  return (
    <Box {...props.wrapperProps} fullWidth>
      {props.label && <Input.Label>{props.label}</Input.Label>}
      <SegmentedControl
        fullWidth
        radius="md"
        styles={SEGMENTED_BORDER_STYLES}
        data={[
          {
            value: "3",
            label: (
              <Center style={{ gap: 10 }}>
                <IconSun size={22} strokeWidth={1.5} />
                <span>{t('logo.gradientBright')}</span>
              </Center>
            ),
          },
          {
            value: "2",
            label: (
              <Center style={{ gap: 10 }}>
                <IconMoon size={22} strokeWidth={1.5} />
                <span>{t('logo.gradientDark')}</span>
              </Center>
            ),
          },
        ]}
        {...props}
      />
    </Box>
  );
};
